import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { cocktailApi, Cocktail } from '../services/cocktailApi.ts';
import './Home.css';

const Home: React.FC = () => {
  const [randomCocktail, setRandomCocktail] = useState<Cocktail | null>(null);

  useEffect(() => {
    loadRandomCocktail();
  }, []);

  const loadRandomCocktail = async () => {
    const cocktail = await cocktailApi.getRandomCocktail();
    setRandomCocktail(cocktail);
  };


  return (
    <div className="home">

      {randomCocktail && (
        <section className="featured">
          <h2>Featured Drink</h2>
          <div className="featured-drink-layout">
            <div className="featured-image-container">
              <Link to={`/cocktail/${randomCocktail.idDrink}`} className="featured-image-link">
                <img
                  src={randomCocktail.strDrinkThumb}
                  alt={randomCocktail.strDrink}
                  className="featured-drink-image"
                />
              </Link>
            </div>
            <div className="featured-drink-info">
              <h3 className="featured-drink-name">{randomCocktail.strDrink}</h3>
              <Link to={`/cocktail/${randomCocktail.idDrink}`} className="featured-view-recipe-btn">
                View Recipe
              </Link>
            </div>
          </div>
          <button onClick={loadRandomCocktail} className="random-btn">
            🍸 New Featured Drink
          </button>
        </section>
      )}
    </div>
  );
};

export default Home;
